export const FETCH_ENTRIES_REQUEST = 'FETCH_ENTRIES_REQUEST';
export const FETCH_ENTRIES_SUCCESS = 'FETCH_ENTRIES_SUCCESS';
export const FETCH_ENTRIES_FAILURE = 'FETCH_ENTRIES_FAILURE';
export const CREATE_ENTRY_REQUEST = 'CREATE_ENTRY_REQUEST';
export const CREATE_ENTRY_SUCCESS = 'CREATE_ENTRY_SUCCESS';
export const CREATE_ENTRY_FAILURE = 'CREATE_ENTRY_FAILURE';
